import React from 'react';

interface CopiedIconProps {
  color: string;
}

const CopiedIcon: React.FC<CopiedIconProps> = ({ color }): JSX.Element => {
  return (
    <svg className="mb-1" width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5804 0.529053C20.1384 1.06616 20.1384 1.93843 19.5804 2.47554L8.15184 13.4755C7.5938 14.0126 6.68755 14.0126 6.12952 13.4755L0.415231 7.97554C-0.142805 7.43843 -0.142805 6.56616 0.415231 6.02905C0.973267 5.49194 1.87952 5.49194 2.43755 6.02905L7.14291 10.5537L17.5626 0.529053C18.1206 -0.00805664 19.0268 -0.00805664 19.5849 0.529053H19.5804Z"
        fill={color}
      />
    </svg>
  );
};

export default CopiedIcon;
